module.exports = __webpack_public_path__ + "img/chev-right-4.4e99c1d5.svg";